import React from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Loader2, CheckCircle, Star, Send } from "lucide-react";

/**
 * Review form shown after delivery is complete
 */
export function DeliveryReviewForm({
  rating,
  setRating,
  comment,
  setComment,
  onSubmit,
  submitting,
  submitted
}) {
  if (submitted) {
    return (
      <div className="border border-border p-6" data-testid="review-section">
        <h2 className="font-bold mb-4">Rate Your Delivery</h2>
        <div className="text-center py-6">
          <CheckCircle className="w-12 h-12 mx-auto text-green-500 mb-3" />
          <p className="font-medium">Thank you for your feedback!</p>
          <p className="text-sm text-muted-foreground">Your review helps us improve our service.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="border border-border p-6" data-testid="review-section">
      <h2 className="font-bold mb-4">Rate Your Delivery</h2>
      <div className="space-y-4">
        {/* Star Rating */}
        <div className="flex items-center gap-2">
          <span className="text-sm text-muted-foreground mr-2">Rating:</span>
          {[1, 2, 3, 4, 5].map((star) => (
            <button
              key={star}
              type="button"
              onClick={() => setRating(star)}
              className="focus:outline-none"
              data-testid={`star-${star}`}
            >
              <Star 
                className={`w-8 h-8 transition-colors ${
                  star <= rating 
                    ? "fill-yellow-400 text-yellow-400" 
                    : "text-gray-300 hover:text-yellow-300"
                }`} 
              />
            </button>
          ))}
        </div>
        
        {/* Comment */}
        <Textarea
          placeholder="Share your experience (optional)"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          className="rounded-none resize-none"
          rows={3}
          data-testid="review-comment"
        />
        
        {/* Submit Button */}
        <Button
          onClick={onSubmit}
          disabled={submitting || rating === 0}
          className="rounded-none gap-2"
          data-testid="submit-review-btn"
        >
          {submitting ? (
            <Loader2 className="w-4 h-4 animate-spin" />
          ) : (
            <Send className="w-4 h-4" />
          )}
          Submit Review
        </Button>
      </div>
    </div>
  );
}
